var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4409 9.32757C28.2881 9.15717 28.0681 9.05957 27.8385 9.05957H12.1625C11.9329 9.05957 11.7145 9.15717 11.5609 9.32757C11.4073 9.49797 11.3329 9.72597 11.3577 9.95397L13.5089 30.4748C13.5513 30.8852 13.8993 31.1996 14.3137 31.1996H25.6857C26.1017 31.1996 26.4481 30.8852 26.4921 30.474L28.6433 9.95397C28.6681 9.72517 28.5937 9.49797 28.4409 9.32757ZM26.9393 10.6796L26.4865 14.998H13.5145L13.0617 10.6796H26.9393ZM24.9577 29.5812H15.0433L13.6841 16.6188H26.3177L24.9577 29.5812Z",
    fill: "#009BD4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/Water.46444466e08ff9b9e9bc6a8614840bdb.svg";
export { ForwardRef as ReactComponent };